<app-modal-filler-atom
  (click)="closeVoucher()"
  [index]="(index$ | async) ?? 0"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 overflow-y-auto shadow max-h-85-screen md:flex md:justify-center md:items-center md:w-full md:h-full"
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="keyboardOffset"
  [class.bottom-0]="keyboardOffset === 0 && (settingsSelector.selectDeviceIsMobileScreen | async)"
>
  <app-input-voucher-atom
    (applyVoucher)="applyVoucher($event)"
    (closeVoucher)="closeVoucher()"
    [error]="errorVoucher ?? ''"
    [isValidating]="isValidating"
  ></app-input-voucher-atom>
</div>
